import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemeModeService } from '../../../core/theme/theme-mode.service';

@Component({
  selector: 'app-theme-switcher',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './theme-switcher.html',
  styleUrl: './theme-switcher.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSwitcher {
  protected readonly theme = inject(ThemeModeService);
}
